import * as constants from './constants';
import * as selectors from './selectors';
import reducer from './reducer';
import * as backend from './backend';
import * as testBackend from './testBackend';

const injectableReducer = { [constants.NAMESPACE]: reducer };
export { constants, reducer, selectors, injectableReducer, backend, testBackend };

export default reducer;
